import defaultIcon from '../assets/default-metric.svg';
import foreignGlobeIcon from '../assets/general/foreign-globe.svg';
import popIcon from '../assets/general/population.svg';
import homeownerIcon from '../assets/general/home-ownership.svg';
import povertyIcon from '../assets/general/200-poverty-rate.svg';
import limitedEnglishIcon from '../assets/general/limited-english.svg';
import internetIcon from '../assets/general/internet.svg';
import unemploymentIcon from '../assets/general/unemployment-rate.svg';
import medianHomeValueIcon from '../assets/general/median-home.svg';
import laborForceIcon from '../assets/general/laborforce.svg';
import raceIcon from '../assets/general/raceethnicity.svg';
import immigrationIcon from '../assets/general/descent-group.svg';
import hhIncomeIcon from '../assets/general/annualhhincome.svg';
import jobsIcon from '../assets/general/jobs.svg';
import transit2jobsIcon from '../assets/general/transit-to-jobs.svg';
import auto2jobsIcon from '../assets/general/auto-to-jobs.svg';
import collegeIcon from '../assets/general/college.svg';
import transitCommutersIcon from '../assets/general/transit-commute.svg';
import costBurdenedIcon from '../assets/general/cost-burdened.svg';
import lowLifeIcon from '../assets/general/low-life.svg';
import pmIcon from '../assets/general/particulate-matter.svg';
import toxicIcon from '../assets/general/toxic.svg';
import dieselIcon from '../assets/general/diesel-emissions.svg';
import trafficIcon from '../assets/general/high-traffic.svg';
import asthmaIcon from '../assets/general/asthma.svg';
import urbanTreeIcon from '../assets/general/urban-tree-canopy.svg';
import noiseIcon from '../assets/general/noise-pollution.svg';
import floodIcon from '../assets/general/flood-risk.svg';
import heatIcon from '../assets/general/heat-and-temp.svg';
import voterIcon from '../assets/general/voter-participation.svg';
import parksIcon from '../assets/general/parks.svg';
import bikeIcon from '../assets/general/bicycle.svg';
import healthyFoodIcon from '../assets/general/healthy-food.svg';
import walkabilityIcon from '../assets/general/walkabilityindex.svg';
import disabledIcon from '../assets/general/IndividualsWithDisabilities.svg';
import ageIcon from '../assets/general/grandparents.svg';
import incomeIcon from '../assets/general/income.svg';
import qualityJobsIcon from '../assets/general/qualityjobs.svg';
import internetSpeedIcon from '../assets/general/InternetSpeed.svg';
import healthInsuranceIcon from '../assets/general/HealthInsuranceRate.svg';
import libraryIcon from '../assets/general/library-access.svg';
import retailIcon from '../assets/general/retail-jobs.svg';
import parksQualityIcon from '../assets/general/qualityparks.svg';
import roadIcon from '../assets/general/road-conditions.svg';
import vehicleIcon from '../assets/general/vehicle.svg';
import crashIcon from '../assets/general/fatal-crash.svg';
import selfHealthIcon from '../assets/general/self-rated-health.svg';
import studentMobilityIcon from '../assets/general/student-mobility.svg';
import studentTestIcon from '../assets/general/studenttest.svg';
import kinderIcon from '../assets/general/kindergarten.svg';
import ozoneIcon from '../assets/general/ozone.svg';
import commuteIcon from '../assets/general/commute.svg';
import familyIcon from '../assets/general/family.svg';
import personOutlineIcon from '../assets/general/person-outline.svg';
import houseIcon from '../assets/general/house.svg';
import vacantHouseIcon from '../assets/general/house-outline.svg';
import housingCostBurdenIcon from '../assets/general/housing-cost-burden.svg';
import childIcon from '../assets/general/children.svg';
import snapIcon from '../assets/general/snap.svg';
import lunchIcon from '../assets/general/lunch.svg';

// Map metric names (normalized) to their icons
export const iconMap: Record<string, string> = {
    'foreign born': foreignGlobeIcon,
    'foreign-born population': foreignGlobeIcon,
    'population': popIcon,
    'current population': popIcon,
    'total population': popIcon,
    'population density': popIcon,
    'poverty rate': povertyIcon,
    'limited english': limitedEnglishIcon,
    'limited english proficiency': limitedEnglishIcon,
    'at home languages': limitedEnglishIcon,
    'households with internet': internetIcon,
    'home internet access': internetIcon,
    'internet access': internetIcon,
    'computer and internet access': internetIcon,
    'households under 200% poverty': povertyIcon,
    '200% poverty rate': povertyIcon,
    'families under 200% poverty': povertyIcon,
    'unemployment rate': unemploymentIcon,
    'median home value': medianHomeValueIcon,
    'home ownership rate': homeownerIcon,
    'homeowners': homeownerIcon,
    'home owners': homeownerIcon,
    'renters': homeownerIcon,
    'labor force': laborForceIcon,
    'race': raceIcon,
    'ethnicity': raceIcon,
    'race & ethnicity': raceIcon,
    'race / ethnicity': raceIcon,
    'race and ethnicity': raceIcon,
    'people of color': raceIcon,
    'top countries of immigration': immigrationIcon,
    'countries of immigration': immigrationIcon,
    'individuals with disabilities': disabledIcon,
    'share of population with a disability': disabledIcon,
    'jobs': jobsIcon,
    'estimated jobs total': jobsIcon,
    'employment by industry': jobsIcon,
    'job density': jobsIcon,
    'workers within 45 minutes by transit': transit2jobsIcon,
    'household income': hhIncomeIcon,
    'median household income': hhIncomeIcon,
    'annual household income - white': hhIncomeIcon,
    'annual household income - black or african american': hhIncomeIcon,
    'annual household income - native hawaiian and other pacific islander': hhIncomeIcon,
    'annual household income - asian': hhIncomeIcon,
    'annual household income - american indian and alaska native': hhIncomeIcon,
    'annual household income - two or more races': hhIncomeIcon,
    'annual household income - some other race': hhIncomeIcon,
    'annual household income - hispanic / latino/a/x of any race': hhIncomeIcon,
    'individuals with college degrees': collegeIcon,
    'four-year cohort graduation rate': collegeIcon,
    'high school graduation rate': collegeIcon,
    'high school diploma/ged+': collegeIcon,
    "bachelor's degree or more": collegeIcon,
    "bachelor's degree+": collegeIcon,
    "bachelor’s degree or more": collegeIcon,
    'ged or equivalent or more': collegeIcon,
    "master's degree or more": collegeIcon,
    "master's degree+": collegeIcon,
    'four-year high school graduation': collegeIcon,
    'high school diploma/ ged': collegeIcon,
    'without high school diploma/ ged': collegeIcon,
    "age 25+ with a master's degree+": collegeIcon,
    "age 25+ with a bachelor's degree+": collegeIcon,
    "age 25+ with hs diploma/ged": collegeIcon,
    "age 25+ without hs diploma/ged": collegeIcon,
    '4-year high school graduation rate': collegeIcon,
    'elementary school enrollment (grades 1–4)': studentTestIcon,
    'elementary school enrollment (grades 5–8)': studentTestIcon,
    'high school enrollment (grades 9–12)': studentTestIcon,
    'graduate or professional school enrollment': studentTestIcon,
    'undergraduate college enrollment': studentTestIcon,
    'kindergarten enrollment': kinderIcon,
    'nursery or preschool enrollment': kinderIcon,
    'transit access': transit2jobsIcon,
    'transit commuters as % of workforce': transitCommutersIcon,
    'cost burdened households': costBurdenedIcon,
    'share of households that are cost-burdened': costBurdenedIcon,
    'share of renter households that are cost-burdened': costBurdenedIcon,
    'share of owner households that are cost-burdened': costBurdenedIcon,
    'cost burdened renters': costBurdenedIcon,
    'cost-burdened renters': costBurdenedIcon,
    'cost-burdened homeowners': costBurdenedIcon,
    'share income spent on mortgage': costBurdenedIcon,
    'share income spent on rent': costBurdenedIcon,
    'cost-burdened households': costBurdenedIcon,
    'cost-burdened renter households': costBurdenedIcon,
    'cost-burdened owner households': costBurdenedIcon,
    'homeownership rate': homeownerIcon,
    'housing units': houseIcon,
    'multifamily units': houseIcon,
    'rental units': houseIcon,
    'percent low life expectancy': lowLifeIcon,
    'pm2.5 particulates': pmIcon,
    'toxic releases from facilities': toxicIcon,
    'diesel emissions': dieselIcon,
    'proximity to heavy traffic roadways': trafficIcon,
    'asthma rates': asthmaIcon,
    'urban tree canopy': urbanTreeIcon,
    'noise pollution': noiseIcon,
    'flood risk': floodIcon,
    'heat & temperature': heatIcon,
    'four year average voter participation rate': voterIcon,
    'voter participation rate': voterIcon,
    'regional park access': parksIcon,
    'neighborhood park access': parksIcon,
    'community park access': parksIcon,
    'park index score': parksIcon,
    'pedestrian and bike facilities': bikeIcon,
    'healthy food availability': healthyFoodIcon,
    'healthy food access': healthyFoodIcon,
    'reduced and free lunch eligibility': healthyFoodIcon,
    'access to healthy food': healthyFoodIcon,
    'accessing calfresh benefits': healthyFoodIcon,
    'walkability index': walkabilityIcon,
    'transit to jobs index': transit2jobsIcon,
    'auto to jobs index': auto2jobsIcon,
    'jobs within 20-minute drivetime': auto2jobsIcon,
    'age': ageIcon,
    'labor force participation rate': laborForceIcon,
    'average weekly wage': incomeIcon,
    'individuals earning more than 200% fpl': incomeIcon,
    'quality jobs index': qualityJobsIcon,
    'internet speed': internetSpeedIcon,
    'health insurance rate': healthInsuranceIcon,
    'pedestrian and bike trails': parksIcon,
    'library access': libraryIcon,
    'retail service jobs': retailIcon,
    'average road quality': roadIcon,
    'parks access': parksQualityIcon,
    'access to household vehicle': vehicleIcon,
    'household vehicle access': vehicleIcon,
    'health uninsured rate': healthInsuranceIcon,
    'fatal/serious injury crashes': crashIcon,
    'self-rated health': selfHealthIcon,
    'educational attainment': libraryIcon,
    'average student mobility rate': studentMobilityIcon,
    'average student test scores': studentTestIcon,
    'four-year high school graduation rate': collegeIcon,
    'kindergarten readiness': kinderIcon,
    'heavy traffic roadways': trafficIcon,
    'nox-diesel emissions': dieselIcon,
    'pm2.5 concentration': pmIcon,
    'ozone concentration': ozoneIcon,
    'commute mode': commuteIcon,
    'child to adult ratio': familyIcon,
    'children without health insurance': healthInsuranceIcon,
    'individuals without health insurance': healthInsuranceIcon,
    'children under 5 in poverty': personOutlineIcon,
    'population under 18': childIcon,
    'grandparents living with grandchildren': ageIcon,
    'age 3 and 4 school enrollment': kinderIcon,
    'hours needed per week at minimum wage to afford median rent': houseIcon,
    'residential mobility': studentMobilityIcon,
    'resident turnover': studentMobilityIcon,
    'vacant housing': vacantHouseIcon,
    'housing cost burden': housingCostBurdenIcon,
    'accessing snap benefits': snapIcon,
    'workers that are non-auto commuters': commuteIcon,
    'free or reduced-price lunch eligibility': lunchIcon,

    // add more mappings here
};

export function getIconByName(name?: string): string {
    if (!name) return defaultIcon;

    const normalized = name.toLowerCase().trim();
    return iconMap[normalized] || defaultIcon;
}

export { defaultIcon };